/**
 * Path helpers and tab ids for Asset Management (assets + rental sections).
 * Paths must stay in sync with menuConfig and App.js redirects.
 */
export const ASSET_TAB_ASSETS = "assets";
export const ASSET_TAB_INSURANCE = "insurance";
export const ASSET_TAB_VENDORS = "vendors";
export const ASSET_TAB_RENTAL_LEASES = "leases";
export const ASSET_TAB_RENT_LEDGER = "ledger";

export function buildAssetManagementPath({ tab } = {}) {
  const t = tab != null ? String(tab).trim() : "";
  if (!t || t === ASSET_TAB_ASSETS) return "/AssetManagement";
  return `/AssetManagement?tab=${encodeURIComponent(t)}`;
}
